import moment from "moment";

class UserApi {
  async searchUsers(admin_id,search_text,page_number,limit_per_page) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/users_all/search/`
    const values = {
      "admin_id": admin_id,
      "search_text" : search_text,
      "page_number": page_number, 
      "limit_per_page": limit_per_page
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }

  // Fonction servant à filtrer les utilisateurs selon différents critères
  async searchUsersTrainer(admin_id, search_text, page_number, limit_per_page, audit_id, start_session = null, end_session = null, feedback_filter = null) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/users_all/learners_feedbacks/`

    let formattedStartDate = null
    let formattedEndDate = null

    if (start_session) {
      const parsedDate = moment(start_session, "DD/MM/YYYY")
      formattedStartDate = parsedDate.format('YYYY-MM-DD')
    }
    if (end_session) {
      const parsedDate = moment(end_session, "DD/MM/YYYY")
      formattedEndDate = parsedDate.format('YYYY-MM-DD')

    }

    const values = {
      "admin_id": admin_id,
      "search_text" : search_text,
      "page_number": page_number, 
      "limit_per_page": limit_per_page,
      'audit_id': audit_id,
      "start_session": formattedStartDate,
      "end_session": formattedEndDate,
      "feedback_filter": feedback_filter
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }

  // Fonction servant à récupérer les dates de session d'un audit
  async getSessionDates(admin_id, audit_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/users_all/session_dates/`
    const values = {
      "admin_id": admin_id,
      "audit_id": audit_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }

  async getUsers(admin_id,page_number,limit_per_page) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/users_all/get/`
    const values = {
      "admin_id": admin_id,
      "page_number": page_number, 
      "limit_per_page": limit_per_page
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }
  
  async getUsersStats(admin_id, customer_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/users_stats/get/`
    const values = {
      "admin_id": admin_id,
      "customer_id": customer_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }

  async getUsersStatsFormateur(admin_id, customer_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/users_stats_formateur/get/`
    const values = {
      "admin_id": admin_id,
      "customer_id": customer_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }

  async getUsersActivities(admin_id, customer_id, page = 1, pageSize = 1) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${localStorage.getItem('tenant')}/api/users_activities/get/`;
    const values = {
      "admin_id": admin_id,
      "customer_id": customer_id,
      "page": page,
      "page_size": pageSize
    };
    const tenant = localStorage.getItem('tenant');
    const accessToken = localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }
  

  async getLastActivities(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/activities/getLast/`
    const values = {
      "admin_id": admin_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }
  
  async getAllActivities(admin_id, page = 1, limit = 25, filters = {}) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/activities/getAll/`
    const values = {
        "admin_id": admin_id,
        "page": page,
        "limit": limit,
        "filters": filters // Ajoutez les filtres ici
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
        }
    });
    const json = await resp.json();
    return Promise.resolve(json)
}
  
  async getEppByType(admin_id, type) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/audits_all/get/`
    const values = {
      "admin_id": admin_id,
      "type": type
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }
  async createUser(admin_id, data) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/create_user/`
    const values = {
      "admin_id": admin_id,
      "firstname": data.firstname,
      "lastname": data.lastname,
      "email": data.email,
      "tlms_id": data.tlms_id !== '' ? parseInt(data.tlms_id, 10) : null,
      "syna_id": data.syna_id !== '' ? parseInt(data.syna_id, 10) : null
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json)
  }


  async sendIds(admin_id, users_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/credentials/crm/sent/`
    const values = {
      "admin_id": admin_id,
      "users_id": users_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }
  async modifyUser(admin_id, user) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/user/modify/`
    const values = {
      "admin_id": admin_id,
      "user_id": user.details.id,
      "firstname": user.details.firstname,
      "lastname": user.details.lastname,
      "email": user.details.email,
      "tlms_id": user.details.tlms_id,
      "syna_id": user.details.syna_id,
      "auto_relaunch": user.details.auto_relaunch,
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }
  async createAdmin(admin_id, data, access_level, id_service, roles_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/create_admin/`;
    const values = {
      "admin_id": admin_id,
      "firstname": data.firstname,
      "lastname": data.lastname,
      "email": data.email,
      "avatar": data.avatar,
      "password": data.password,
      "access_level": access_level,
      "id_service": id_service,
      "roles_id": roles_id, // Utilisez roles_id au lieu de role_id
    };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }

  async getGroups(adminId) {
    const tenant = globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/groupes/getAllGroupes/`;
  
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      }
    });
  
    return await response.json();
  }
  async getUserGroups(adminId, userId) {
    try {
      const tenant = globalThis.localStorage.getItem('tenant');
      const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
      const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/users/${userId}/groups/`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,  // Utilisez accessToken au lieu de userId
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      return data.data; // Retourne directement le tableau des groupes
    } catch (error) {
      console.error('Error fetching user groups:', error);
      throw error;
    }
  }
  
  async assignUserToGroup(adminId, userId, groupId) {
    const tenant = globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/users/assignUserToGroup/${userId}/`;
  
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({ groupe_id: groupId })
    });
  
    return await response.json();
  }
  
  async removeUserFromGroup(adminId, userId, groupId) {
    const tenant = globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
    const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/users/removeUserFromGroup/${userId}/`;
  
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({ groupe_id: groupId })
    });
  
    return await response.json();
  }
  

}

export const userApi = new UserApi();